import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import './ProfileSuggestionModal.scss';
import { putRequest, deleteRequest } from '../../requestUtils';
var ProfileSuggestionModal = /*#__PURE__*/function (_Component) {
  function ProfileSuggestionModal(props) {
    var _this;
    _classCallCheck(this, ProfileSuggestionModal);
    _this = _callSuper(this, ProfileSuggestionModal, [props]);
    _this.state = {
      showModal: props.forceShow,
      isHovering: false
    };
    _this.handleShowModal = _this.handleShowModal.bind(_this);
    _this.handleHideModal = _this.handleHideModal.bind(_this);
    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
    _this.handleDecline = _this.handleDecline.bind(_this);
    _this.handleAccept = _this.handleAccept.bind(_this);
    _this.handleRemove = _this.handleRemove.bind(_this);
    return _this;
  }
  _inherits(ProfileSuggestionModal, _Component);
  return _createClass(ProfileSuggestionModal, [{
    key: "handleMouseOver",
    value: function handleMouseOver() {
      this.setState({
        isHovering: true
      });
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      this.setState({
        isHovering: false
      });
    }
  }, {
    key: "handleHideModal",
    value: function handleHideModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "handleShowModal",
    value: function handleShowModal() {
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "handleAccept",
    value: function handleAccept() {
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        appendTags = _this$props.appendTags,
        tags = _this$props.tags;
      return putRequest('/profile_suggestions', {
        profile_suggestion_ids: tags.map(function (tag) {
          return tag.id;
        })
      }, csrfToken).then(function () {
        appendTags(tags.map(function (tag) {
          return {
            image: null,
            label: tag.label,
            value: tag.taggable_id
          };
        }));
      });
    }
  }, {
    key: "handleDecline",
    value: function handleDecline() {
      var _this$props2 = this.props,
        csrfToken = _this$props2.csrfToken,
        clearTags = _this$props2.clearTags,
        tags = _this$props2.tags;
      var tagIds = tags.map(function (tag) {
        return tag.id;
      });
      return deleteRequest("/profile_suggestions/?profile_suggestion_ids=[".concat(tagIds, "]"), csrfToken).then(function () {
        clearTags(tagIds);
      });
    }
  }, {
    key: "handleRemove",
    value: function handleRemove(e) {
      e.preventDefault();
      var _this$props3 = this.props,
        csrfToken = _this$props3.csrfToken,
        clearTags = _this$props3.clearTags;
      var tagId = Number(e.target.dataset.id);
      deleteRequest("/profile_suggestions/?profile_suggestion_ids=[".concat(tagId, "]"), csrfToken).then(function () {
        clearTags([tagId]);
      });
    }
  }, {
    key: "renderModalButton",
    value: function renderModalButton() {
      var _this$props4 = this.props,
        showEdit = _this$props4.showEdit,
        editMode = _this$props4.editMode,
        tags = _this$props4.tags;
      var isHovering = this.state.isHovering;
      if (tags.length === 0) return null;
      return /*#__PURE__*/React.createElement("span", {
        className: "profile-suggestion-modal-button",
        onMouseOver: this.handleMouseOver,
        onMouseLeave: this.handleMouseLeave
      }, /*#__PURE__*/React.createElement("a", {
        role: "button",
        tabIndex: 0,
        onClick: this.handleShowModal
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-magic wand"
      }), "\xA0", /*#__PURE__*/React.createElement("span", {
        className: "blue-circle"
      }, tags.length), showEdit && (isHovering || editMode) && /*#__PURE__*/React.createElement("span", null, "\xA0\xA0Edit")));
    }
  }, {
    key: "renderModal",
    value: function renderModal() {
      var _this2 = this;
      var tags = this.props.tags;
      return /*#__PURE__*/React.createElement(Modal, {
        show: this.state.showModal,
        onHide: this.handleHideModal,
        dialogClassName: "profile-suggestion-modal"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement(Modal.Body, {
        className: "profile-suggestion-card"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cta row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-md-10 col-xs-8"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cta-text mb-2"
      }, "Suggestions for", ' ', tags.length && tags[0].title || 'N/A')), /*#__PURE__*/React.createElement("div", {
        className: "col-md-1 col-xs-2"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-magic wand"
      }), "\xA0\xA0", /*#__PURE__*/React.createElement("span", {
        className: "blue-circle"
      }, tags.length))), /*#__PURE__*/React.createElement("div", {
        className: "cta row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-md-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, "Level up your profile by accepting Clora recommendations."))), /*#__PURE__*/React.createElement("div", {
        className: "row profile-suggestion-color"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tags mb-2 mt-15"
      }, tags.map(function (t) {
        return /*#__PURE__*/React.createElement("span", {
          key: t.label,
          className: "badge small normal-font me-3"
        }, t.label, "\xA0\xA0", /*#__PURE__*/React.createElement("i", {
          role: "button",
          "data-id": t.id,
          onClick: _this2.handleRemove,
          className: "fas fa-times",
          tabIndex: 0
        }));
      }))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
        className: "row button-row profile-suggestion-color"
      }, /*#__PURE__*/React.createElement("div", {
        className: "suggestion-button decline-button col-md-6 col-xs-6",
        onClick: this.handleDecline,
        role: "button",
        tabIndex: 0
      }, "Decline Suggestions"), /*#__PURE__*/React.createElement("div", {
        className: "suggestion-button accept-button col-md-6 col-xs-6",
        onClick: this.handleAccept,
        role: "button",
        tabIndex: 0
      }, "Add Suggestions"))));
    }
  }, {
    key: "render",
    value: function render() {
      var tags = this.props.tags;
      if (tags.length === 0) return null;
      return /*#__PURE__*/React.createElement("span", null, "\xA0\xA0", this.renderModalButton(), this.renderModal());
    }
  }]);
}(Component);
ProfileSuggestionModal.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  csrfToken: PropTypes.string,
  appendTags: PropTypes.func.isRequired,
  clearTags: PropTypes.func.isRequired,
  showEdit: PropTypes.bool,
  editMode: PropTypes.bool,
  forceShow: PropTypes.bool
};
ProfileSuggestionModal.defaultProps = {
  csrfToken: '',
  showEdit: true,
  editMode: false,
  forceShow: false
};
export default ProfileSuggestionModal;